import { render, staticRenderFns } from "./PreScreeningQuestions.vue?vue&type=template&id=5d6a1678&scoped=true&"
import script from "./PreScreeningQuestions.vue?vue&type=script&lang=ts&"
export * from "./PreScreeningQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./PreScreeningQuestions.vue?vue&type=style&index=0&id=5d6a1678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6a1678",
  null
  
)

export default component.exports